import { apiClient, handleResponse } from './axios';

async function getObjectives() {
  try {
    const response = await apiClient
      .get('/objectives');
    const objectives = await handleResponse(response);
    return objectives;
  } catch (error) {
    return error.response;
  }
}

async function updateObjectives(objectiveId, body) {
  try {
    const response = await apiClient
      .put(`/objectives/${objectiveId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

const objectiveServices = {
  getObjectives,
  updateObjectives,
};

export default objectiveServices;
